import {Mapper} from '@s-ui/domain'

/**
 * @implements Mapper
 */
export default class TrackingProxyMapper extends Mapper {
  /**
   * @constructor
   * @param {Mapper} param.fromPageTrackingJsonToTrackingDataValueObjectMapper
   * @param {Mapper} param.trackingAdsDetailMapper
   * @param {Mapper} param.trackingAdsListMapper
   * @param {Mapper} param.trackingAppraisalVehicleMapper
   * @param {Mapper} param.trackingAuthenticationMapper
   * @param {Mapper} param.trackingDealersListVehicleMapper
   * @param {Mapper} param.trackingErrorMapper
   * @param {Mapper} param.trackingInstantOfferPageMapper
   * // web_seller_instant_offer_landing_test
   * @param {Mapper} param.trackingLandingInstantOfferTestMapper
   * @param {Mapper} param.trackingNewsDetailMapper
   * @param {Mapper} param.trackingNewsGallerySearchMapper
   * @param {Mapper} param.trackingNewsMapper
   * @param {Mapper} param.trackingModelDetailMapper
   * @param {Mapper} param.trackingProfessionalStockMapper
   * @param {Mapper} param.trackingPublishYourCarWithPlateMapper
   * @param {Mapper} param.trackingTechnicalDetailsMapper
   * @param {Mapper} param.trackingUserFavoritesMapper
   * @param {Mapper} param.trackingUserFavoritesDealersMapper
   * @param {Mapper} param.trackingUserProfileEditMapper
   * @param {Mapper} param.trackingWdylMapper
   * @param {Object} param
   * @param {Object} param.config
   * @param {ValueObject} param.valueObject
   * @param {Mapper} param.trackingCheckoutSuccessMapper
   */
  constructor({
    config,
    fromPageTrackingJsonToTrackingDataValueObjectMapper,
    trackingAdsDetailMapper,
    trackingAdsListMapper,
    trackingAppraisalVehicleMapper,
    trackingAuthenticationMapper,
    trackingComparatorMapper,
    trackingDealersListMapper,
    trackingCheckoutSuccessMapper,
    trackingErrorMapper,
    trackingInstantOfferPageMapper,
    // web_seller_instant_offer_landing_test
    trackingLandingInstantOfferTestMapper,
    trackingNewsDetailMapper,
    trackingNewsGallerySearchMapper,
    trackingNewsMapper,
    trackingModelDetailMapper,
    trackingPageVehicleConfiguratorMapper,
    trackingPageVehicleSuggesterMapper,
    trackingProfessionalStockMapper,
    trackingPublishMyAdMapper,
    trackingPublishYourCarWithPlateMapper,
    trackingPublishYourCarWithPlateResultsMapper,
    trackingRecommendationsMapper,
    trackingTechnicalDetailsMapper,
    trackingUserFavoritesMapper,
    trackingUserFavoritesDealersMapper,
    trackingUserProfileEditMapper,
    trackingWdylMapper,
    valueObject
  }) {
    super()

    this._config = config
    this._fromPageTrackingJsonToTrackingDataValueObjectMapper = fromPageTrackingJsonToTrackingDataValueObjectMapper
    this._valueObject = valueObject
    this._customMappers = {
      COMPARADOR: trackingComparatorMapper,
      ADS_DETAIL_PREVIEW: trackingAdsDetailMapper,
      ADS_DETAIL: trackingAdsDetailMapper,
      ADS_LIST_AUTOCARAVANS_AND_TRAILERS: trackingAdsListMapper,
      ADS_LIST_BUGGIES_NEW: trackingAdsListMapper,
      ADS_LIST_BUGGIES: trackingAdsListMapper,
      ADS_LIST_CARS_WITHOUT_LICENSE: trackingAdsListMapper,
      ADS_LIST_CLASSIC_AND_COMPETITION: trackingAdsListMapper,
      ADS_LIST_FILTERS: trackingAdsListMapper,
      ADS_LIST_MINIMOTOS_NEW: trackingAdsListMapper,
      ADS_LIST_MINIMOTOS: trackingAdsListMapper,
      ADS_LIST_NEW: trackingAdsListMapper,
      ADS_LIST_QUADS_NEW: trackingAdsListMapper,
      ADS_LIST_QUADS: trackingAdsListMapper,
      ADS_LIST_SUBSCRIPTION: trackingAdsListMapper,
      ADS_LIST_BUSINESS_SUBSCRIPTION: trackingAdsListMapper,
      ADS_LIST_VANS_AND_COMMERCIAL: trackingAdsListMapper,
      ADS_LIST: trackingAdsListMapper,
      APPRAISAL_VEHICLE: trackingAppraisalVehicleMapper,
      CHECKOUT_SUCCESS: trackingCheckoutSuccessMapper,
      COMPLETE_REGISTRATION_ERROR: trackingAuthenticationMapper,
      DEALERS_LIST: trackingDealersListMapper,
      EDIT_MY_AD: trackingPublishMyAdMapper,
      ERROR: trackingErrorMapper,
      INSTANT_OFFER_SELL_TO_DEALER: trackingInstantOfferPageMapper,
      // web_seller_instant_offer_landing_test
      LANDING_INSTANT_OFFER_TEST: trackingLandingInstantOfferTestMapper,
      LINK_ACCOUNT_ERROR: trackingAuthenticationMapper,
      LOGIN_ERROR: trackingAuthenticationMapper,
      NEWS_CATEGORY: trackingNewsMapper,
      NEWS_DETAIL_GALLERY_IMAGE: trackingNewsDetailMapper,
      NEWS_DETAIL: trackingNewsDetailMapper,
      NEWS_COMMENTS: trackingNewsDetailMapper,
      NEWS_GALLERY_SEARCH: trackingNewsGallerySearchMapper,
      NEWS_SEARCH: trackingNewsMapper,
      NEWS_SECTION_TIPS: trackingNewsMapper,
      NEWS_SECTION_TRENDS: trackingNewsMapper,
      NEWS_TAG: trackingNewsMapper,
      MAKE: trackingModelDetailMapper,
      MAKES_DISTRIBUTOR: trackingModelDetailMapper,
      MODEL_DETAIL: trackingModelDetailMapper,
      MODEL_DETAIL_INTERIOR: trackingModelDetailMapper,
      MODEL_DETAIL_TRUNK: trackingModelDetailMapper,
      MODEL_SIZES: trackingModelDetailMapper,
      PROFESSIONAL_STOCK: trackingProfessionalStockMapper,
      PROFESSIONAL_STOCK_RENTING: trackingProfessionalStockMapper,
      PUBLISH_MY_AD: trackingPublishMyAdMapper,
      PUBLISH_YOUR_VEHICLE_WITH_PLATE: trackingPublishYourCarWithPlateMapper,
      PUBLISH_YOUR_VEHICLE_WITH_PLATE_RESULTS: trackingPublishYourCarWithPlateResultsMapper,
      RECOMMENDATIONS: trackingRecommendationsMapper,
      REGISTER_VALIDATION_ERROR: trackingAuthenticationMapper,
      TECHNICAL_DETAILS_BODY_TYPE: trackingTechnicalDetailsMapper,
      TECHNICAL_DETAILS_COMPARATOR_RESULTS: trackingTechnicalDetailsMapper,
      TECHNICAL_DETAILS_MAKE: trackingTechnicalDetailsMapper,
      TECHNICAL_DETAILS_MODEL: trackingTechnicalDetailsMapper,
      TECHNICAL_DETAILS_RESUME: trackingTechnicalDetailsMapper,
      TECHNICAL_DETAILS_SEARCH_ENGINE: trackingTechnicalDetailsMapper,
      TECHNICAL_DETAILS_SEARCH_RESULTS: trackingTechnicalDetailsMapper,
      TECHNICAL_DETAILS_SEARCH: trackingTechnicalDetailsMapper,
      TECHNICAL_DETAILS_VEHICLE_WITHOUT_VERSION: trackingTechnicalDetailsMapper,
      TECHNICAL_DETAILS_VEHICLE: trackingTechnicalDetailsMapper,
      TECHNICAL_DETAILS_VERSION: trackingTechnicalDetailsMapper,
      USER_FAVORITE_ADS: trackingUserFavoritesMapper,
      USER_FAVORITE_DEALERS: trackingUserFavoritesDealersMapper,
      USER_PROFILE_EDIT: trackingUserProfileEditMapper,
      VEHICLE_CONFIGURATOR_MAKE_MODEL: trackingPageVehicleConfiguratorMapper,
      VEHICLE_CONFIGURATOR_FUEL_TYPE: trackingPageVehicleConfiguratorMapper,
      VEHICLE_CONFIGURATOR_TRIM_LEVEL: trackingPageVehicleConfiguratorMapper,
      VEHICLE_CONFIGURATOR_ENGINE: trackingPageVehicleConfiguratorMapper,
      VEHICLE_CONFIGURATOR_COLOR: trackingPageVehicleConfiguratorMapper,
      VEHICLE_CONFIGURATOR_FORM: trackingPageVehicleConfiguratorMapper,
      VEHICLE_CONFIGURATOR_RESULTS: trackingPageVehicleConfiguratorMapper,
      VEHICLE_CONFIGURATOR_ZIPCODE: trackingPageVehicleConfiguratorMapper,
      VEHICLE_CONFIGURATOR_SUCCESS: trackingPageVehicleConfiguratorMapper,
      VEHICLE_CONFIGURATOR_ERROR_GENERIC: trackingPageVehicleConfiguratorMapper,
      VEHICLE_CONFIGURATOR_ERROR_CONTENT: trackingPageVehicleConfiguratorMapper,
      VEHICLE_CONFIGURATOR_ERROR_CONNECTION: trackingPageVehicleConfiguratorMapper,
      VEHICLE_CONFIGURATOR: trackingPageVehicleConfiguratorMapper,
      VEHICLE_SUGGESTER_PRICE_RANGE: trackingPageVehicleSuggesterMapper,
      VEHICLE_SUGGESTER_BODY_TYPE: trackingPageVehicleSuggesterMapper,
      VEHICLE_SUGGESTER_FUEL_TYPE: trackingPageVehicleSuggesterMapper,
      VEHICLE_SUGGESTER_SEATS: trackingPageVehicleSuggesterMapper,
      VEHICLE_SUGGESTER_MAKES: trackingPageVehicleSuggesterMapper,
      VEHICLE_SUGGESTER_RESULTS: trackingPageVehicleSuggesterMapper,
      WDYL: trackingWdylMapper
    }
  }

  /**
   * @param {Object} param
   * @param {String} param.page
   * @param {String} param.culture
   */
  createFor({page, culture}) {
    switch (page) {
      case 'COMPARADOR':
      case 'ADS_DETAIL':
      case 'ADS_DETAIL_PREVIEW':
      case 'ADS_LIST':
      case 'ADS_LIST_AUTOCARAVANS_AND_TRAILERS':
      case 'ADS_LIST_BUGGIES':
      case 'ADS_LIST_BUGGIES_NEW':
      case 'ADS_LIST_CARS_WITHOUT_LICENSE':
      case 'ADS_LIST_CLASSIC_AND_COMPETITION':
      case 'ADS_LIST_FILTERS':
      case 'ADS_LIST_MINIMOTOS':
      case 'ADS_LIST_MINIMOTOS_NEW':
      case 'ADS_LIST_NEW':
      case 'ADS_LIST_QUADS':
      case 'ADS_LIST_QUADS_NEW':
      case 'ADS_LIST_VANS_AND_COMMERCIAL':
      case 'ADS_LIST_SUBSCRIPTION':
      case 'ADS_LIST_BUSINESS_SUBSCRIPTION':
      case 'APPRAISAL_VEHICLE':
      case 'CHECKOUT_SUCCESS':
      case 'COMPLETE_REGISTRATION_ERROR':
      case 'DEALERS_LIST':
      case 'EDIT_MY_AD':
      case 'ERROR':
      case 'INSTANT_OFFER_SELL_TO_DEALER':
      case 'LANDING_INSTANT_OFFER_TEST': // web_seller_instant_offer_landing_test
      case 'LINK_ACCOUNT_ERROR':
      case 'LOGIN_ERROR':
      case 'MAKE':
      case 'MAKES_DISTRIBUTOR':
      case 'MODEL_DETAIL':
      case 'MODEL_DETAIL_INTERIOR':
      case 'MODEL_DETAIL_TRUNK':
      case 'MODEL_SIZES':
      case 'NEWS_CATEGORY':
      case 'NEWS_DETAIL':
      case 'NEWS_COMMENTS':
      case 'NEWS_DETAIL_GALLERY_IMAGE':
      case 'NEWS_GALLERY_SEARCH':
      case 'NEWS_SEARCH':
      case 'NEWS_SECTION_TIPS':
      case 'NEWS_SECTION_TRENDS':
      case 'NEWS_TAG':
      case 'PROFESSIONAL_STOCK':
      case 'PROFESSIONAL_STOCK_RENTING':
      case 'PUBLISH_MY_AD':
      case 'PUBLISH_YOUR_VEHICLE_WITH_PLATE':
      case 'PUBLISH_YOUR_VEHICLE_WITH_PLATE_RESULTS':
      case 'RECOMMENDATIONS':
      case 'REGISTER_VALIDATION_ERROR':
      case 'TECHNICAL_DETAILS_BODY_TYPE':
      case 'TECHNICAL_DETAILS_COMPARATOR_RESULTS':
      case 'TECHNICAL_DETAILS_MAKE':
      case 'TECHNICAL_DETAILS_MODEL':
      case 'TECHNICAL_DETAILS_RESUME':
      case 'TECHNICAL_DETAILS_SEARCH':
      case 'TECHNICAL_DETAILS_SEARCH_ENGINE':
      case 'TECHNICAL_DETAILS_SEARCH_RESULTS':
      case 'TECHNICAL_DETAILS_VEHICLE':
      case 'TECHNICAL_DETAILS_VEHICLE_WITHOUT_VERSION':
      case 'TECHNICAL_DETAILS_VERSION':
      case 'USER_FAVORITE_ADS':
      case 'USER_FAVORITE_DEALERS':
      case 'USER_PROFILE_EDIT':
      case 'VEHICLE_CONFIGURATOR':
      case 'VEHICLE_CONFIGURATOR_MAKE_MODEL':
      case 'VEHICLE_CONFIGURATOR_FUEL_TYPE':
      case 'VEHICLE_CONFIGURATOR_TRIM_LEVEL':
      case 'VEHICLE_CONFIGURATOR_ENGINE':
      case 'VEHICLE_CONFIGURATOR_COLOR':
      case 'VEHICLE_CONFIGURATOR_FORM':
      case 'VEHICLE_CONFIGURATOR_RESULTS':
      case 'VEHICLE_CONFIGURATOR_ZIPCODE':
      case 'VEHICLE_CONFIGURATOR_SUCCESS':
      case 'VEHICLE_CONFIGURATOR_ERROR_GENERIC':
      case 'VEHICLE_CONFIGURATOR_ERROR_CONTENT':
      case 'VEHICLE_CONFIGURATOR_ERROR_CONNECTION':
      case 'VEHICLE_SUGGESTER_PRICE_RANGE':
      case 'VEHICLE_SUGGESTER_BODY_TYPE':
      case 'VEHICLE_SUGGESTER_FUEL_TYPE':
      case 'VEHICLE_SUGGESTER_SEATS':
      case 'VEHICLE_SUGGESTER_MAKES':
      case 'VEHICLE_SUGGESTER_RESULTS':
      case 'WDYL':
        return data =>
          this._customMappers[page].map({
            page,
            culture,
            data
          })
      default:
        return this._fromPageTrackingJsonToTrackingDataValueObjectMapper.setParams({
          page,
          culture
        }).map
    }
  }
}
